module.exports = __webpack_public_path__ + "img/head_5.b9be92ad.png";